// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"651":"fcba5106d24354f2","741":"1461f8579c99c4ea"}[chunkId] + ".js";
};